import { createSvgIcon } from '@mui/material';

const PersonIcon = createSvgIcon(
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.99967 7.33333C8.70692 7.33333 9.3852 7.05238 9.88529 6.55228C10.3854 6.05219 10.6663 5.37391 10.6663 4.66667C10.6663 3.95942 10.3854 3.28115 9.88529 2.78105C9.3852 2.28095 8.70692 2 7.99967 2C7.29243 2 6.61415 2.28095 6.11406 2.78105C5.61396 3.28115 5.33301 3.95942 5.33301 4.66667C5.33301 5.37391 5.61396 6.05219 6.11406 6.55228C6.61415 7.05238 7.29243 7.33333 7.99967 7.33333Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4 14V12.6667C4 11.9594 4.28095 11.2811 4.78105 10.781C5.28115 10.281 5.95942 10 6.66667 10H9.33333C10.0406 10 10.7189 10.281 11.219 10.781C11.719 11.2811 12 11.9594 12 12.6667V14"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    'Person'
);

export default PersonIcon;
